import React from 'react';

import { number, string, bool, object, func } from 'prop-types';
import styled, { css } from 'styled-components';

import { Component as ImageZoom } from '../ImageZoom';
import { Component as ProductImage } from '../ProductImage';

const StyledPicture = styled(ProductImage)`
  ${({ isHoverEnabled }) =>
    isHoverEnabled
      ? css`
          &:hover {
            cursor: crosshair;
          }
        `
      : ''}

  ${({ isModelImageFullScreen }) =>
    isModelImageFullScreen
      ? css`
          height: 100%;
          object-fit: cover;
        `
      : ''}
`;

const ZoomWrapper = styled.div`
  ${({ isClickToZoom }) =>
    isClickToZoom
      ? css`
          position: relative;
          height: 100%;
        `
      : ''}
`;

const StyledImageZoom = styled(ImageZoom)`
  height: ${({ isModelImageFullScreen }) =>
    isModelImageFullScreen ? '100%' : 'unset'};
`;

function ModelThumbnail({
  activeImageIndex,
  angle,
  isModelImageFullScreen,
  isClickToZoom,
  isZoomable = false,
  model,
  onZoomChange,
}) {
  const { modelIndex, product } = model;
  const isHoverEnabled = !isClickToZoom;

  if (isZoomable) {
    return (
      <ZoomWrapper
        isClickToZoom={isClickToZoom}
        isModelImageFullScreen={isModelImageFullScreen}
      >
        <StyledImageZoom
          isModelImageFullScreen={isModelImageFullScreen}
          isHoverEnabled={isHoverEnabled}
          isPanEnabled={!isHoverEnabled}
          maxZoom={2}
          onZoomChange={onZoomChange}
          zoomKey={
            isClickToZoom && isModelImageFullScreen ? activeImageIndex : null
          }
        >
          <StyledPicture
            angle={angle}
            isHoverEnabled={isHoverEnabled}
            isModelImageFullScreen={isModelImageFullScreen}
            modelIndex={modelIndex}
            product={product}
            size={9}
          />
        </StyledImageZoom>
      </ZoomWrapper>
    );
  }

  return (
    <ProductImage
      product={product}
      modelIndex={modelIndex}
      angle={angle}
      size={8}
    />
  );
}

ModelThumbnail.propTypes = {
  activeImageIndex: number,
  angle: string,
  isClickToZoom: bool,
  isModelImageFullScreen: bool,
  isZoomable: bool,
  model: object,
  onZoomChange: func,
};

export default ModelThumbnail;
